export const EMPLOYMENT_TYPE = {
    'ADVISOR': 'Advisor',
    'CPA': 'CPA',
    'ATTORNEY': 'Attorney',
    'FUND_MANAGER': 'Fund Manager',
    'INDUSTRY_LEADER': 'Industry Leader',
    'SPOUSE': 'Spouse',
    'NON_ADVISOR_STAFF': 'Non-Advisor Staff',
    'PARTNER': 'Partner',
    'STUDENT': 'Student',
    'EDUCATOR': 'Educator',
    'MINISTRY': 'Ministry',
    'RETIRED': 'Retired',
    'CONFERENCE_TEAM': 'Conference Team'
};

export const employmentArray = [
    {
        value: EMPLOYMENT_TYPE.ADVISOR,
        label: 'Advisor'
    },
    {
        value: EMPLOYMENT_TYPE.CPA,
        label: 'CPA'
    },
    {
        value: EMPLOYMENT_TYPE.ATTORNEY,
        label: 'Attorney'
    },
    {
        value: EMPLOYMENT_TYPE.FUND_MANAGER,
        label: 'Fund Manager'
    },
    {
        value: EMPLOYMENT_TYPE.INDUSTRY_LEADER,
        label: 'Industry Leader'
    },
    {
        value: EMPLOYMENT_TYPE.SPOUSE,
        label: 'Spouse of financial services professional'
    },
    {
        value: EMPLOYMENT_TYPE.NON_ADVISOR_STAFF,
        label: 'Non-Advisor Staff at firm'
    },
    {
        value: EMPLOYMENT_TYPE.PARTNER,
        label: 'Partner'
    },
    {
        value: EMPLOYMENT_TYPE.STUDENT,
        label: 'Student'
    },
    {
        value: EMPLOYMENT_TYPE.EDUCATOR,
        label: 'University faculty/Educator'
    },
    {
        value: EMPLOYMENT_TYPE.MINISTRY,
        label: 'Ministry'
    },
    {
        value: EMPLOYMENT_TYPE.RETIRED,
        label: 'Retired'
    },
    {
        value: EMPLOYMENT_TYPE.CONFERENCE_TEAM,
        label: 'Conference Team'
    }
];

export const CONFERENCE_TEAM = {
    SPEAKER: 'Speaker',
    SPEAKER_ASSISTANT: 'Speaker Assistant',
    KA_STAFF: 'KA Staff',
    FULL_TIME_CONF_VOL: 'Full-time conference volunteer',
    AV_TEAM: 'A/V Team'
};

export const SPECIALTY_TYPE = {
    FINANCIAL_PLANNER: 'Financial Planner',
    INVEST_MANAGER: 'Investment Manager',
    WEALTH_MANAGER: 'Wealth Manager (FP+IM)',
    ACCOUNTANT: 'Accountant',
    ATTORNEY: 'Attorney',
    INSURANCE: 'Insurance',
    OTHER: 'Other'
};

export const specialtyArray = [
    {
        value: SPECIALTY_TYPE.FINANCIAL_PLANNER,
        label: 'Financial Planner'
    },
    {
        value: SPECIALTY_TYPE.INVEST_MANAGER,
        label: 'Investment Manager'
    },
    {
        value: SPECIALTY_TYPE.WEALTH_MANAGER,
        label: 'Wealth Manager (FP+IM)'
    },
    {
        value: SPECIALTY_TYPE.ACCOUNTANT,
        label: 'Accountant'
    },
    {
        value: SPECIALTY_TYPE.ATTORNEY,
        label: 'Attorney'
    },
    {
        value: SPECIALTY_TYPE.INSURANCE,
        label: 'Insurance'
    },
    {
        value: SPECIALTY_TYPE.OTHER,
        label: 'Other'
    }
];

export const NUMBER_OF_EMPLOYEES = {
    LESS_10: '< 10',
    ELEVEN_TO_TWENTYFIVE: '11-25',
    TWENTYSIX_TO_FIFTY: '26-50',
    FIFTYONE_TO_100: '51-100',
    HUNDRED_TO_250: '101-250',
    GREATER_TWOFIFTY: '250+'
};

export const numberOfEmployeesArray = [
    {
        value: NUMBER_OF_EMPLOYEES.LESS_10,
        label: '< 10'
    },
    {
        value: NUMBER_OF_EMPLOYEES.ELEVEN_TO_TWENTYFIVE,
        label: '11-25'
    },
    {
        value: NUMBER_OF_EMPLOYEES.TWENTYSIX_TO_FIFTY,
        label: '26-50'
    },
    {
        value: NUMBER_OF_EMPLOYEES.FIFTYONE_TO_100,
        label: '51-100'
    },
    {
        value: NUMBER_OF_EMPLOYEES.HUNDRED_TO_250,
        label: '101-250'
    },
    {
        value: NUMBER_OF_EMPLOYEES.GREATER_TWOFIFTY,
        label: '250+'
    }
];

export const PRIMARY_CLIENT_SEGMENT = {
    MASS_AFFLUENT: 'Mass Affluent',
    AFFLUENT: 'Affluent',
    HNW: 'HNW',
    UHNW_FAMILY_OFFICE: 'UHNW / Family Office'
};

export const primaryClientSegmentArray = [
    {
        value: PRIMARY_CLIENT_SEGMENT.MASS_AFFLUENT,
        label: 'Mass Affluent'
    },
    {
        value: PRIMARY_CLIENT_SEGMENT.AFFLUENT,
        label: 'Affluent'
    },
    {
        value: PRIMARY_CLIENT_SEGMENT.HNW,
        label: 'HNW'
    },
    {
        value: PRIMARY_CLIENT_SEGMENT.UHNW_FAMILY_OFFICE,
        label: 'UHNW / Family Office'
    }
];

export const FIRM_TYPE = {
    RIA: 'RIA',
    LARGE_FIRM: 'Large Firm',
    BROKER_DEALER: 'Broker Dealer',
    BANK_TRUST: 'Bank/Trust',
    INSURANCE: 'Insurance',
    LAW_FIRM: 'Law Firm',
    ACCOUNTING_FIRM: 'Accounting Firm',
    OTHER: 'Other'
};

export const firmTypeArray = [
    {
        value: FIRM_TYPE.RIA,
        label: 'RIA'
    },
    {
        value: FIRM_TYPE.LARGE_FIRM,
        label: 'Large Firm'
    },
    {
        value: FIRM_TYPE.BROKER_DEALER,
        label: 'Broker Dealer'
    },
    {
        value: FIRM_TYPE.BANK_TRUST,
        label: 'Bank/Trust'
    },
    {
        value: FIRM_TYPE.INSURANCE,
        label: 'Insurance'
    },
    {
        value: FIRM_TYPE.LAW_FIRM,
        label: 'Law Firm'
    },
    {
        value: FIRM_TYPE.ACCOUNTING_FIRM,
        label: 'Accounting Firm'
    },
    {
        value: FIRM_TYPE.OTHER,
        label: 'Other'
    }
];

export const ASSETS_UNDER_MANAGE = {
    LESS_100M: '< 100M',
    HUNDRED_TO_250M: '100-250M',
    TWOFIFTY_TO_500M: '250-500M',
    FIVEHUNDRED_TO_1B: '500M-1B',
    GREATER_1B: '1B+',
    NON_AVAILABLE: 'NA'
};

export const assetsUnderManageArray = [
    {
        value: ASSETS_UNDER_MANAGE.LESS_100M,
        label: '< 100M'
    },
    {
        value: ASSETS_UNDER_MANAGE.HUNDRED_TO_250M,
        label: '100-250M'
    },
    {
        value: ASSETS_UNDER_MANAGE.TWOFIFTY_TO_500M,
        label: '250-500M'
    },
    {
        value: ASSETS_UNDER_MANAGE.FIVEHUNDRED_TO_1B,
        label: '500M-1B'
    },
    {
        value: ASSETS_UNDER_MANAGE.GREATER_1B,
        label: '1B+'
    },
    {
        value: ASSETS_UNDER_MANAGE.NON_AVAILABLE,
        label: 'NA'
    }
];

export const YEARS_IN_BUSINESS = {
    LESS_5: '< 5',
    FIVE_TO_TEN: '5-10',
    ELEVEN_TO_15: '11-15',
    GREATER_15: '15+'
};

export const yearsInBusinessArray = [
    {
        value: YEARS_IN_BUSINESS.LESS_5,
        label: '< 5'
    },
    {
        value: YEARS_IN_BUSINESS.FIVE_TO_TEN,
        label: '5-10'
    },
    {
        value: YEARS_IN_BUSINESS.ELEVEN_TO_15,
        label: '11-15'
    },
    {
        value: YEARS_IN_BUSINESS.GREATER_15,
        label: '15+'
    }
];

export const SPECIAL_INTERESTS = {
    COMPREHENSIVE_FINANCIAL_PLANNING: 'Comprehensive Financial Planning',
    FAITH_BASED_INVESTING: 'Faith-Based Investing',
    ESTATE_PLANNING: 'Estate Planning',
    RETIREMENT_PLANNING: 'Retirement Planning',
    SUCCESSION_PLANNING: 'Succession Planning',
    TAX_PLANNING: 'Tax Planning',
    BUSINESS_TRANSITION: 'Business Transition'
};

export const CREDENTIALS = {
    CKA: 'CKA®',
    CFP: 'CFP®',
    ChFC: 'ChFC®',
    CPA: 'CPA',
    CPA_PFS: 'CPA/PFS',
    CFA: 'CFA®',
    CIMA: 'CIMA',
    AAMS: 'AAMS®',
    EA: 'EA',
    CLU: 'CLU®',
    FIC: 'FIC',
    JD: 'JD'
};

export const credentialsArray = [
    {
        value: CREDENTIALS.CKA,
        label: 'CKA®'
    },
    {
        value: CREDENTIALS.CFP,
        label: 'CFP®'
    },
    {
        value: CREDENTIALS.ChFC,
        label: 'ChFC®'
    },
    {
        value: CREDENTIALS.CPA,
        label: 'CPA'
    },
    {
        value: CREDENTIALS.CPA_PFS,
        label: 'CPA/PFS'
    },
    {
        value: CREDENTIALS.CFA,
        label: 'CFA®'
    },
    {
        value: CREDENTIALS.CIMA,
        label: 'CIMA'
    },
    {
        value: CREDENTIALS.AAMS,
        label: 'AAMS®'
    },
    {
        value: CREDENTIALS.EA,
        label: 'EA'
    },
    {
        value: CREDENTIALS.CLU,
        label: 'CLU®'
    },
    {
        value: CREDENTIALS.FIC,
        label: 'FIC'
    },
    {
        value: CREDENTIALS.JD,
        label: 'JD'
    }
];
